import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {ResourceModel} from "../../../core/models/resources/resource.model";
import {OrganizationHierarchyStoreService} from "../../../service/store/organization-hierarchy-store/organization-hierarchy-store.service";
import { ResourceType } from "../../../core/helpers/Const";

@Component({
    selector: 'app-show-parent-data-btn',
    templateUrl: './show-parent-data-btn.component.html',
    styleUrls: ['./show-parent-data-btn.component.scss'],
    standalone: false
})
export class ShowParentDataBtnComponent implements OnChanges {

  @Output() toggleParentData = new EventEmitter<ResourceModel>();

  @Input() isFclOpen: boolean;
  @Input() parentPath: string;
  @Input() selectedRow: ResourceModel;
  @Input() currentOrg: string;
  @Input() currentResource: string;
  @Input() resourceType: ResourceType;

  title: string;

  constructor(public organizationHierarchyStore: OrganizationHierarchyStoreService) {
  }
  
  ngOnChanges(changes: SimpleChanges) {
      this.title = this.isFclOpen && this.parentPath === this.selectedRow.path ? 'Close Parent Details' : 'View Parent Details';
  }

  async showParentData() {
      if (this.resourceType === ResourceType.ORGANIZATION) {
          const org = await this.organizationHierarchyStore.getOrFetchOrganization(this.currentResource);
          this.toggleParentData.emit(org);
      } else {
          const resource = await this.organizationHierarchyStore
              .getOrFetchContainer(this.currentOrg, this.parentPath, this.currentResource, this.resourceType);
          this.toggleParentData.emit(resource);
      }
  }
}
